import styles from './ForYouLeadingIcon.module.css'
import {clsx} from 'clsx'
import type {Icon as PrimerIcon} from '@primer/octicons-react'

export type ForYouLeadingIconVariant = 'default' | 'danger' | 'success' | 'warning' | 'info' | 'done'

type ForYouLeadingIconProps = {
  icon: PrimerIcon
  /** Optional visual variant controlling the leading icon color */
  variant?: ForYouLeadingIconVariant
  /** Whether to render the icon with the larger status treatment */
  emphasized?: boolean
}

export function ForYouLeadingIcon({icon: Icon, variant = 'default', emphasized = false}: ForYouLeadingIconProps) {
  return (
    <span className={clsx(styles.variant, styles[variant], emphasized && styles.emphasized)}>
      <Icon size={emphasized ? 24 : 16} />
    </span>
  )
}
